<template>
  <div class="container testimonials" id="testimonials">
    <div class="content-heading is-flex">
      <h3 class="is-size-3">Properties</h3>
      <router-link to="/admin/properties/new" class="button is-info">Add New</router-link>
    </div>

    <transition mode="out-in" name="fade">
      <modal @close="showModal = false" :kind="kind" @confirmDeletePost='confirmDelete()' @selectBulkActions='selectBulkActions()' v-if="showModal" :header="header"/>
    </transition>

    <router-view></router-view>

    <div class="box">
      <table class="table is-fullwidth is-striped">
        <thead>
          <tr>
            <th>
              Name
            </th>
            <th>
              Type
            </th>
            <th>
              Location
            </th>
            <th>
              State
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(property, index) in properties" :key="index">
            <td>
              <p>
                <router-link :to="'/admin/properties/edit/' + property['.key']">
                  {{property.name}}
                </router-link>
              </p>
            </td>
            <td>
              <p>{{property.type}}</p>
            </td>
            <td>{{property.location}}</td>
            <td>{{property.state}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- notification -->
    <transition mode="out-in" name="fade">
      <div v-if="notification.message" :class="'notification is-' + notification.type">
        <button class="delete" @click="hideNotifications"></button>{{notification.message}}
      </div>
    </transition>
  </div>
</template>

<script>
// import firebase from 'firebase'
import { propertiesRef } from '@/firebase_config'
import modal from '@/components/shared/Modal'
import notifier from '@/mixins/notifier'

export default {
  name: 'properties',
  data () {
    return {
      showModal: false,
      header: '',
      kind: '',
      property: null,
      sortKey: 'title'
    }
  },
  firebase: {
    properties: propertiesRef
  },
  mixins: [notifier],
  computed: {},
  methods: {
    deleteProperty (property) {
      this.header = 'Are you sure you want to delete this property?'
      this.kind = 'deletePost'
      this.showModal = true
      this.property = property
    },
    confirmDelete () {
      this.$firebaseRefs.properties.child(this.property['.key']).remove().then(() => {
        this.showNotification('success', 'Testimonial deleted successfully')
        this.showModal = false
        this.property = ''
      })
    }
  },
  components: {
    modal
    // dropdown,
    // checkbox
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/content/Properties.vue